import { TALK_TO_SALE_LINK } from './constants';

const FALLBACK_DATASET_TITLE = 'Public Sample Recording';

const encodeDatasetTitleForUrl = (value?: string): string => {
  const normalized = value?.trim() || FALLBACK_DATASET_TITLE;
  return encodeURIComponent(normalized);
};

export const buildTalkToSalesLink = (datasetTitle?: string): string =>
  TALK_TO_SALE_LINK.replace(
    '{dataset_title}',
    encodeDatasetTitleForUrl(datasetTitle)
  );
